import React from 'react'

interface IconProps {
  size?: number
  color?: string
  strokeWidth?: number
  className?: string
  marginBottom?: string
}

const MarketplaceStallIcon: React.FC<IconProps> = ({
  size = 24,
  color = 'currentColor',
  strokeWidth = 2,
  className = '',
  marginBottom = '0px',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      style={{ marginBottom: marginBottom }}
    >
      {/* Canopy top */}
      <path d="M3 8L7 4H17L21 8H3Z" />
      {/* Awning edge */}
      <path d="M3 8H21" />
      {/* Awning stripes */}
      <path d="M6 8V11" />
      <path d="M10 8V11" />
      <path d="M14 8V11" />
      <path d="M18 8V11" />
      {/* Counter/body */}
      <rect x="4" y="11" width="16" height="9" rx="1" />
      {/* Legs */}
      <path d="M7 20V17" />
      <path d="M17 20V17" />
    </svg>
  )
}

export default MarketplaceStallIcon
